import React from 'react';
import '../css/footer.css';
import { Link } from 'react-router-dom';
import ScrollTop from '../components/scrollTop'

export default function Footer() {
    return (
        <div>
            <ScrollTop/>
            <footer className="footer">
                <div className="container py-5">
                    <div className="row">
                        {/* Column 1 */}
                        <div className="col-lg-4 col-md-3 col-sm-6 mb-4 mb-lg-0">
                            <Link to="/" className='text-decoration-none'><h3 className="brand-title">Online Shop Matrix</h3></Link>
                            <p className="brand-text">
                                We bring you a seamless online shopping experience with a wide range
                                of products, exclusive deals, and secure checkout – all in one place.
                                Shop smart, save more, and enjoy convenience at your fingertips.
                            </p>
                            <Link to="/subscribe" className="btn btn-warning text-dark">
                                Subscribe Newsletter
                            </Link>
                        </div>

                        {/* Column 2 */}
                        <div className="col-lg-3 col-md-3 col-sm-6 mb-4 mb-lg-0">
                            <ul className="footer-links list-unstyled">
                                <li><Link to="/blogs">LATEST BLOGS</Link></li>
                                <li><Link to="/category/personal-care/skin-care">SKIN CARE</Link></li>
                                <li><Link to="/category/electronics-accessories/solar-accessories">SOLAR ACCESSORIES</Link></li>
                                <li><Link to="/category/home-essentials/mattress-&-pillow">MATTRESS & PILLOWS</Link></li>
                                <li><Link to="/category/electronics-accessories">ELECTRONICS ACCESSORIES</Link></li>
                            </ul>
                        </div>

                        {/* Column 3 */}
                        <div className="col-lg-3 col-md-3 col-sm-6 mb-4 mb-lg-0">
                            <ul className="footer-links list-unstyled">
                                <li><Link to="/category/saaS">SAAS</Link></li>
                                <li><Link to="/category/pets-care">PETS CARE</Link></li>
                                <li><Link to="/category/personal-care">PERSONAL CARE</Link></li>
                                <li><Link to="/category/home-essentials">HOME ESSENTIALS</Link></li>
                                <li><Link to="/category/gift-card-&-memberships">GIFT CARD & MEMBERSHIPS</Link></li>
                            </ul>
                        </div>

                        {/* Column 4 - New Extra Links */}
                        <div className="col-lg-2 col-md-3 col-sm-6 mb-4 mb-lg-0">
                            <ul className="footer-links list-unstyled text-uppercase">
                                <li><Link to="/category/home-essentials/bathroom">Bathroom</Link></li>
                                <li><Link to="/category/home-essentials/fire-safety">Fire safety</Link></li>
                                <li><Link to="/category/personal-care/weight-loss">weight loss</Link></li>
                                <li><Link to="/category/food-&-beverages">Food & Beverages</Link></li>
                                <li><Link to="/category/electronics-accessories/camera-&-accessories">Camera & accessories</Link></li>
                            </ul>
                        </div>
                    </div>

                    <hr className="footer-divider" />

                    {/* Bottom Bar */}
                    <div className="footer-bottom d-flex flex-column flex-md-row justify-content-between align-items-center py-3">
                        <p className="copyright-text mb-2 mb-md-0">
                            &copy; 2025 Online Shop Matrix | All Rights Reserved.
                        </p>
                        <div className="footer-bottom-links">
                            <Link to="/about">About</Link>
                            <Link to="/contact">Contact Us</Link>
                            <Link to="/privacy-policy">Privacy Policy</Link>
                            <Link to="/return-refund">Return & Refund</Link>
                            <Link to="/terms-and-conditions">Terms & Conditions</Link>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}
